module.exports = __webpack_public_path__ + "img/avatar-1.5671f3d0.png";